import { render, staticRenderFns } from "./DiyoboButton.vue?vue&type=template&id=5f05ecc8&scoped=true"
import script from "./DiyoboButton.vue?vue&type=script&lang=js"
export * from "./DiyoboButton.vue?vue&type=script&lang=js"
import style0 from "./DiyoboButton.vue?vue&type=style&index=0&id=5f05ecc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f05ecc8",
  null
  
)

export default component.exports